
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BaseReport from './reports-v3/BaseReport.vue';
import accountx from '@/store/modules/accountx';
import userx from '@/store/modules/userx';
import { formatDateTimeWithZone } from '@/util/datetime';

@Component({
	components: {},
})
export default class LastSync extends BaseReport {
  public get mwVersion() {
    return accountx.fullAccountData && (accountx.fullAccountData.mwVersion || '2');
  }
  public get supportLvl() {
    return userx.supportLvl || 0;
  }
  public get lastLoaded() {
    return formatDateTimeWithZone(Date.now());
  }
}
